/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { AxiosResponse } from 'axios';
import { baseRequest } from './baseRequest';

const baseRoute = '/client-applications';

export const getClientAppBaseUrl = (clientAppId: string): Promise<AxiosResponse<{ baseUrl: string }>> =>
  baseRequest.get<{ baseUrl: string }>(`${baseRoute}/${clientAppId}/base-url`);
